import { request } from "./request";
import { AnyType, MethodEmun } from "@/types";
import { sha256 } from "js-sha256";

export interface RegProps {
  username: string; //用户名
  password: string; //密码    sha256 转base64
  checkCode: string; //验证码
  nickname: string; //昵称
  phone: string; //手机号
  phoneNum: string; //也是手机号，不知道为啥要这么多手机号
  email?: string; //邮箱
}
export const regist: (p: RegProps) => Promise<AnyType> = (p) => {
  p.password = btoa(sha256(p.password));
  return request({
    url: "/usermgr/user/register",
    params: p,
    method: MethodEmun.post,
  });
};

export interface LoginProps {
  username?: string; //用户名
  password?: string; //密码, 先sha256,再base64后的密文
  grant_type: string;
  client_id: string; //通行证登录使用 client_id，企业登录使用yb_meeting_client, 医百云大后台使用 yb_admin_client
  client_secret: string; // 通行证登录使用  client_secret，企业登录使用123456,医百云大后台使用 123456
  refresh_token?: string;
  access_token?: string;
  checkCode: string; //验证码
  enterpriseId?: string; //租户ID
  systemType?: string; //1-大后台, 2-小后台, 3-前台用户
  passwordMD5?: string; //MD5密码
  openId?: string; //第三方openId
  support_new_token: string; //	是否支持每次都生成新的access_token, 默认 "false"
}

export const oauthToken: (p: LoginProps) => Promise<AnyType> = (p) => {
  p.password = btoa(sha256(p.password));
  return request({
    url: "/usermgr/login/auth",
    params: p,
    method: MethodEmun.post,
  });
};

export const exit: (phone: string) => Promise<AnyType> = (phone) =>
  request({
    url: `/usermgr/user/exit/${phone}`,
    params: { phone },
  });

// 3、获取会议用户信息
export const getUserInfo: () => Promise<AnyType> = () =>
  request({ url: "/confmgr/conference/getUserInfo" });
//发送验证码
export const sendcode: (phone: string) => Promise<AnyType> = (phone) =>
  request({
    url: `/usermgr/sms/send/code`,
    params: { phone },
    method: MethodEmun.post,
  });

interface ModifypasswordProps {
  username: string;
  password: string;
  newPassword: string;
}

//修改密码
export const modifypassword: (
  params: ModifypasswordProps
) => Promise<AnyType> = (params) =>
  request({
    url: `/usermgr/user/modifypassword`,
    params,
    method: MethodEmun.post,
  });

interface UserinfoupdateProps {
  nickname: string;
  headimage: string;
  email: string;
  department: string;
}

// 修改用户信息
export const userinfoupdate: (
  params: UserinfoupdateProps
) => Promise<AnyType> = (params) =>
  request({
    url: `/usermgr/user/info/update`,
    params,
    method: MethodEmun.post,
  });

interface ForgetpasswordProps {
  username: string;
  password: string;
  checkCode: string;
}

// 忘记密码
export const forgetpassword: (
  params: ForgetpasswordProps
) => Promise<AnyType> = (params) =>
  request({
    url: `/usermgr/user/forgetpassword`,
    params,
    method: MethodEmun.post,
  });

export const userlists: (p: any) => Promise<AnyType> = (params) => {
  return request({
    url: "/usermgr/alluser",
    params,
    isQuery: true,
    // method: "post",
  });
};
